export { default } from './SignIcon';
